import { Component, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import {
  MatAutocompleteSelectedEvent,
  MatDatepickerInputEvent,
  MatDialog
} from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";

@Component({
  selector: "app-payout",
  templateUrl: "./payout-settlements.component.html",
  styleUrls: ["./payout-settlements.component.css"],
})
export class PayoutSettlementsComponent implements OnInit {
  _csrf: string;
  request_id: string = "";

  // AG Grid properties
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oPayouts: any = [];
  payouts: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    userId: '',
  };
  prev_disabled = true;
  next_disabled = false;

  userList: any[] = [];
  filteredUserList: any[] = [];
  userSearchValue: string = '';
  isUserSelectOpen: boolean = false;

  // Date picker filter function (allows all dates)
  myFilter = (d: Date | null): boolean => {
    return true; // Allow all dates
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadUserList() {
    if (!this._csrf) {
      return;
    }

    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: '',
      status: 'Active',
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.userList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.userList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.userList = response.data;
        } else {
          this.userList = [];
        }
        this.filteredUserList = this.userList;
      },
      () => {
        this.userList = [];
        this.filteredUserList = [];
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          // View button
          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.marginRight = '5px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, 'Payout Bulk Transfer');
          };
          container.appendChild(viewBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 80
      },
      {
        headerName: 'Name',
        field: 'UserId.name',
        valueGetter: (params) => {
          if (params.data && params.data.UserId && params.data.UserId.name) {
            return params.data.UserId.name;
          }
          return '';
        },
        flex: 1
      },
      {
        headerName: 'As Of Date',
        field: 'AsOfDate',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY');
          }
          return '';
        },
        flex: 1
      },
      { headerName: 'Credit BatchId', field: 'CreditBatchId', flex: 1 },
      { headerName: 'Currency', field: 'CryptoCurrency', flex: 0.8 },
      { headerName: 'Matched Amount', field: 'CryptoAmount', flex: 1 },
      {
        headerName: 'Received Currency',
        field: 'ReceivedCurrency',
        // Rows matched before ReceivedCurrency existed only have CryptoCurrency.
        valueGetter: (params) => params.data ? (params.data.ReceivedCurrency || params.data.CryptoCurrency || '') : '',
        flex: 1
      },
      { headerName: 'Network', field: 'Network', flex: 0.8 },
      { headerName: 'TxnHash', field: 'TxnHash', flex: 1.5 },
      {
        headerName: 'UpdatedAt',
        field: 'updatedAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadUserList();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  goBack() {
    this.request_id = "";
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>, type: Number = 1) {
    if (event.value) {
      console.log(event.value, "event value");
      if (type == 1) {
        this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
      }
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  // Client-side search filter only (frontend filtering, does NOT call API)
  applyFilter(filterValue) {
    this.searchValue = filterValue || '';

    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }

    // Update local payouts for export functionality (frontend filtering only)
    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      var search = searchValue.toLowerCase();
      this.payouts = this.oPayouts.filter(function (x) {
        return (
          (x.TxnHash && x.TxnHash.toLowerCase().includes(search)) ||
          (x.CreditBatchId && x.CreditBatchId.toLowerCase().includes(search)) ||
          (x._id && x._id.toLowerCase().includes(search)) ||
          (x.UserId && x.UserId.name && x.UserId.name.toLowerCase().includes(search)) ||
          (x.CryptoCurrency && x.CryptoCurrency.toLowerCase().includes(search))
        );
      });
    } else {
      this.payouts = this.oPayouts;
    }
  }

  // Calls API with date filters only (fromDate, toDate). Search is NOT sent to API.
  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    // Note: searchValue is NOT included in filter - only date filters are sent to API
    this.userService.getAllPayoutSettlements(this.filter).subscribe((list: any) => {
      this.payouts = list;
      this.oPayouts = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        // Re-apply client-side search filter if it exists
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          // Clear filter if no search value
          this.gridApi.setQuickFilter('');
          this.payouts = this.oPayouts;
        }
      }

      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      } else {
        this.next_disabled = false;
      }
    });
  }

  displayProperJson(jsonData, eventType) {
    console.log(jsonData, eventType, "jsonData in payout Bulk confirm");
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Payout Bulk Transfer"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      userId: '',
    };

    // Clear search filter
    this.searchValue = '';
    this.userSearchValue = '';
    this.filteredUserList = this.userList;
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    // Reset local payouts
    this.payouts = this.oPayouts;

    // Reload data
    this.getData();
  }

  onUserSelectOpened(isOpen: boolean) {
    this.isUserSelectOpen = isOpen;
    if (isOpen) {
      this.userSearchValue = '';
      this.filteredUserList = this.userList;
      setTimeout(() => {
        this.addSearchToSelectPanel();
      }, 150);
    } else {
      this.userSearchValue = '';
      this.filteredUserList = this.userList;
    }
  }

  addSearchToSelectPanel() {
    const panel = document.querySelector('.user-select-panel-payout-settlements-list');
    if (panel) {
      const existingSearch = panel.querySelector('.user-search-container');
      if (existingSearch) {
        existingSearch.remove();
      }

      const searchContainer = document.createElement('div');
      searchContainer.className = 'user-search-container';
      searchContainer.innerHTML = `
        <input type="text" placeholder="Search user..." class="user-search-input" value="${this.userSearchValue || ''}">
      `;

      const searchInput = searchContainer.querySelector('.user-search-input') as HTMLInputElement;
      if (searchInput) {
        searchInput.addEventListener('input', (e: any) => {
          this.userSearchValue = e.target.value;
          this.filterUsers(e);
        });
        searchInput.addEventListener('click', (e: any) => {
          e.stopPropagation();
        });
        searchInput.addEventListener('keydown', (e: any) => {
          e.stopPropagation();
        });
      }

      if (panel.firstChild) {
        panel.insertBefore(searchContainer, panel.firstChild);
      } else {
        panel.appendChild(searchContainer);
      }

      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    }
  }

  filterUsers(event: any) {
    const searchTerm = event ? (event.target ? event.target.value : event) : this.userSearchValue;
    this.userSearchValue = searchTerm || '';

    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredUserList = this.userList;
      return;
    }

    const term = searchTerm.toLowerCase();
    this.filteredUserList = this.userList.filter((user) => {
      const name = (user.name || '').toLowerCase();
      const email = (user.email || '').toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }

  exportArray() {
    this.spinnerService.show();

    // Create export filter with same parameters but without pagination
    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      userId: this.filter.userId || '',
      // Remove pagination to get all data
      page: 1,
      limit: 10000 // Set a very large limit to get all records
    };

    // Fetch all data from API using existing endpoint
    this.userService.getAllPayoutSettlements(exportFilter).subscribe(
      (list: any) => {
        if (list && list.length > 0) {
          // Transform data for export
          let exportData = list.map(x => ({
            ...x,
            UserId: x.UserId ? x.UserId._id : '',
            UserName: x.UserId ? x.UserId.name : '',
          }));
          TableUtil.exportArrayToExcel(exportData, 'PayoutSettlementss');
        } else {
          this.notifSer.info("Info", "No data available to export", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", "Failed to export data. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-settlements/payout-settlements.component.ts